//@ts-ignore
import Swiper, { Pagination, EffectFade, Navigation, Autoplay  } from 'swiper';
Swiper.use([Pagination, EffectFade]);


export namespace FiftyFiftySlider {
	let setupSlider = () => {

        let ffSliders = document.querySelectorAll('.js-ff-slider-wrapper');

        ffSliders.forEach(function(ffSlider, index) {

            // set up our main slider with an index
            let sliderWrapper = ffSlider.querySelector('.js-ff-swiper');
            let mainIndex = index;
            sliderWrapper.classList.add('js-ff-swiper-' + index);

            // set up our wrapper with an index
            let ffWrapper = ffSlider.closest('.js-ff-slider-wrapper');
            ffWrapper.classList.add('ff-slider-' + index);

            // add indexes to our image list
            let sliderImages = ffWrapper.querySelector('.js-slider-images').children;
            const sliderImageArray = [...sliderImages];
            sliderImageArray.forEach(function(sliderImage, index) {
                sliderImage.classList.add('slider-' + mainIndex + '-image-' + index);
            });

            //config and initialize swiper
            const ffSwiper = new Swiper('.js-ff-swiper-' + index, {
                autoplay: {
                    delay: 13000
                },
                slidesPerView: 'auto',
                simulateTouch: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 1000,
                navigation: {
                    nextEl: '.js-slider-next',
                    prevEl: '.js-slider-prev',
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
            });
            ffSwiper.init();

            // show the related image on slide change
            ffSwiper.on('slideChange', function () {
                // remove existing active class
                sliderImageArray.forEach(function(sliderImage, index) {
                    sliderImage.classList.remove('active');
                });
                // set new active
                sliderImageArray[ffSwiper.realIndex].classList.add('active');
            });
        });
	}

	export const init = () => {
		setupSlider();
	}
}
